// extracted by css-extract-rspack-plugin
export default {"container":"_31a680"};